<div class="ui-kit">
  <aside class="ui-kit__sidebar">
    <h1 class="ui-kit__title">UI Kit</h1>
    <p class="ui-kit__subtitle">Componentes comunes (preview)</p>
    <nav class="ui-kit__nav">
      <a
        *ngFor="let item of navItems"
        class="ui-kit__nav-link"
        [class.ui-kit__nav-link--verified]="item.verified"
        [routerLink]="['/public/ui-kit', item.path]"
        routerLinkActive="ui-kit__nav-link--active"
      >
        <span class="ui-kit__nav-link-label">{{ item.label }}</span>
        <span
          *ngIf="item.verified"
          class="material-symbols-rounded ui-kit__nav-verified"
          aria-label="Certificado"
        >verified</span>
      </a>
    </nav>
  </aside>
  <main class="ui-kit__main">
    <router-outlet></router-outlet>
  </main>
</div>
